import React from 'react';
import { Popover, Tooltip } from 'antd';
import Span from './../Span';
import './EllipsisText.less';
export default class EllipsisText extends React.Component {

    render() {
        const { title, content, hoverContent, contentMaxWidth, overlayClassName, overlayComponent, className } = this.props;
        const OverlayComponent = overlayComponent || Tooltip;
        return (
            <OverlayComponent trigger="hover" title={title} content={hoverContent || content} overlayClassName={overlayClassName}>
                <Span className={`text-ellipsis ${className || ''}`} style={{ maxWidth: contentMaxWidth }}>{content}</Span>
            </OverlayComponent>
        )
    }
}

EllipsisText.defaultProps = {
    title: '',
    content: '',
    contentMaxWidth: 100,
    overlayClassName: undefined,
}